// React Libraries
import React from 'react';
import Snackbar from '@mui/joy/Snackbar';

// Local components
import { CloseIcon } from '../../icons/FontAwesomeIcon';
import { Body2 } from '../../themes/typography';

export default function SnackBar({
    openSnack,
    setOpenSnack,
    message = 'Link Copied',
    color = 'primary',
    variant = 'soft'
}) {
    return (
        <React.Fragment>
            <Snackbar
                color={color}
                autoHideDuration={3000}
                open={openSnack}
                // startDecorator={<CloseIcon />} // Optional to show icons
                variant={variant}
                onClose={() => {
                    setOpenSnack(false);
                }}
            >
                <Body2 color="#11203A">{message}</Body2>
            </Snackbar>
        </React.Fragment>
    );
}

// openStack => to accept the state value to show or hide the snackbar
// setOpenSnack => to set the value of openStack to show or hide the snackbar
// message => to display the message in the snackbar
// autoHideDuration => to set the duration for which the snackbar will be visible
// variant => to set the variant of the snackbar
// onClose => to close the snackbar when clicked on button

// Demo to reuse the Snackbar component in different components
// Define State in the parent component to handle the snackbar
// Pass setOpenSnack(false) on close button click
// Pass onClick function where you want to perform onclick action and set setOpenSnack(true) to show the snackbar
// const [openSnack, setOpenSnack] = useState(false);
// <SnackBar openSnack={openSnack} setOpenSnack={setOpenSnack} message="Snackbar Message" />
